import { render, staticRenderFns } from "./ProfileWorkSamples.vue?vue&type=template&id=d5b227b6"
import script from "./ProfileWorkSamples.vue?vue&type=script&lang=ts"
export * from "./ProfileWorkSamples.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5b227b6')) {
      api.createRecord('d5b227b6', component.options)
    } else {
      api.reload('d5b227b6', component.options)
    }
    module.hot.accept("./ProfileWorkSamples.vue?vue&type=template&id=d5b227b6", function () {
      api.rerender('d5b227b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ProfileWorkSamples.vue"
export default component.exports